function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;

var __defNormalProp = function __defNormalProp(obj, key, value) {
  return key in obj ? __defProp(obj, key, {
    enumerable: true,
    configurable: true,
    writable: true,
    value: value
  }) : obj[key] = value;
};

var __spreadValues = function __spreadValues(a, b) {
  for (var prop in b || (b = {})) {
    if (__hasOwnProp.call(b, prop)) __defNormalProp(a, prop, b[prop]);
  }

  if (__getOwnPropSymbols) {
    var _iterator = _createForOfIteratorHelper(__getOwnPropSymbols(b)),
        _step;

    try {
      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        var prop = _step.value;
        if (__propIsEnum.call(b, prop)) __defNormalProp(a, prop, b[prop]);
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }
  }

  return a;
};

var __spreadProps = function __spreadProps(a, b) {
  return __defProps(a, __getOwnPropDescs(b));
}; // src/index.tsx


import * as React from "react";

var DefaultComp = function DefaultComp(_ref) {
  var type = _ref.type;
  throw new Error("Could not find a component mapping for type \"".concat(type, "\""));
};

var MapToComponents = function MapToComponents(_ref2) {
  var getKey = _ref2.getKey,
      getType = _ref2.getType,
      list = _ref2.list,
      map = _ref2.map,
      meta = _ref2.meta,
      mapDataToContext = _ref2.mapDataToContext,
      mapDataToProps = _ref2.mapDataToProps,
      _ref2$default = _ref2.default,
      Default = _ref2$default === void 0 ? DefaultComp : _ref2$default,
      defaultMapDataToContext = _ref2.defaultMapDataToContext,
      defaultMapDataToProps = _ref2.defaultMapDataToProps;
  if (!list) return null;
  var keys = list.map(getKey);
  var types = list.map(getType);
  var comps = types.map(function (type) {
    var _a;

    return (_a = map[type]) != null ? _a : Default;
  });

  var gatherData = function gatherData(index) {
    return {
      list: list,
      keys: keys,
      types: types,
      comps: comps,
      map: map,
      meta: meta,
      index: index,
      data: list[index],
      key: keys[index],
      type: types[index],
      Comp: comps[index],
      previousData: list[index - 1],
      previousKey: keys[index - 1],
      previousType: types[index - 1],
      PreviousComp: comps[index - 1],
      nextData: list[index + 1],
      nextKey: keys[index + 1],
      nextType: types[index + 1],
      NextComp: comps[index + 1]
    };
  };

  var contexts = list.map(function (_, index) {
    var _a;

    var fn = (_a = mapDataToContext == null ? void 0 : mapDataToContext[types[index]]) != null ? _a : defaultMapDataToContext;
    return fn ? fn(gatherData(index)) : void 0;
  });

  var gatherDataForMapDataToProps = function gatherDataForMapDataToProps(index) {
    return __spreadProps(__spreadValues({}, gatherData(index)), {
      contexts: contexts,
      context: contexts[index],
      previousContext: contexts[index - 1],
      nextContext: contexts[index + 1]
    });
  };

  var propsList = list.map(function (_, index) {
    var _a;

    var fn = (_a = mapDataToProps == null ? void 0 : mapDataToProps[types[index]]) != null ? _a : defaultMapDataToProps;
    return fn ? fn(gatherDataForMapDataToProps(index)) : void 0;
  });
  return /* @__PURE__ */React.createElement(React.Fragment, null, propsList.map(function (mappedProps, index) {
    var Comp = comps[index];
    var type = types[index];
    var isDefault = Comp === Default;

    if (isDefault) {
      return /* @__PURE__ */React.createElement(Default, __spreadValues({
        key: keys[index],
        type: type
      }, mappedProps));
    }

    return /* @__PURE__ */React.createElement(Comp, __spreadValues({
      key: keys[index]
    }, mappedProps));
  }));
};

export { MapToComponents };